import { createSlice } from "@reduxjs/toolkit";

const dashboardSlice = createSlice({
	name: "dashboard",
	initialState: { notificationMessage: { show: false, message: "", severity: "success" } },
	reducers: {
		hideNotificationMessage(state) {
			state.notificationMessage.show = false;
			return state;
		},
		showSuccessMessage(state, action) {
			state.notificationMessage = {
				message: action.payload,
				show: true,
				severity: "success",
			};
			return state;
		},
		showErrorMessage(state, action) {
			state.notificationMessage = {
				message: action.payload,
				show: true,
				severity: "error",
			};
			return state;
		},
	},
});

export const { showSuccessMessage, showErrorMessage, hideNotificationMessage } = dashboardSlice.actions;
export default dashboardSlice.reducer;
